import React from "react";
import styles from "./ToggleSwitch.module.scss";

interface ToggleSwitchProps {
  value: boolean | 'monthly' | 'annual';
  leftLabel: string;
  rightLabel: string;
  onChange: (value: any) => void;
  name: string;
  leftValue?: any;
  rightValue?: any;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  value,
  leftLabel,
  rightLabel,
  onChange,
  name,
  leftValue,
  rightValue
}) => {
  // Determine if the left option is active
  const isLeftActive = value === (leftValue !== undefined ? leftValue : false) || 
                      value === (leftValue !== undefined ? leftValue : 'monthly');
  
  // Determine if the right option is active
  const isRightActive = value === (rightValue !== undefined ? rightValue : true) || 
                       value === (rightValue !== undefined ? rightValue : 'annual');
  
  // Handle toggle click
  const handleToggleClick = () => {
    if (isLeftActive) {
      onChange(rightValue !== undefined ? rightValue : (typeof value === 'boolean' ? true : 'annual'));
    } else {
      onChange(leftValue !== undefined ? leftValue : (typeof value === 'boolean' ? false : 'monthly'));
    }
  };

  return (
    <div className={styles.toggleContainer}>
      <label
        className={`${styles.toggleOption} ${
          isLeftActive ? styles.active : ""
        }`}
      >
        <input
          type="radio"
          name={name}
          checked={isLeftActive}
          onChange={() => onChange(leftValue !== undefined ? leftValue : (typeof value === 'boolean' ? false : 'monthly'))}
        />
        <span>{leftLabel}</span>
      </label>
      <div 
        className={styles.toggleSwitch}
        onClick={handleToggleClick}
      >
        <div 
          className={styles.toggleIndicator}
          style={{ left: isLeftActive ? '0' : '16px' }}
        ></div>
      </div>
      <label
        className={`${styles.toggleOption} ${
          isRightActive ? styles.active : ""
        }`}
      >
        <input
          type="radio"
          name={name}
          checked={isRightActive}
          onChange={() => onChange(rightValue !== undefined ? rightValue : (typeof value === 'boolean' ? true : 'annual'))}
        />
        <span>{rightLabel}</span>
      </label>
    </div>
  );
};

export default ToggleSwitch;